module.exports = __webpack_public_path__ + "img/ststephens.b668131.png";